import { render } from "./easyCamera.vue?vue&type=template&id=088da7ee"
import script from "./easyCamera.vue?vue&type=script&lang=js"
export * from "./easyCamera.vue?vue&type=script&lang=js"

import "./easyCamera.vue?vue&type=style&index=0&id=088da7ee&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__